export default __webpack_public_path__ + "static/book-like-no-other-bg-40c978a3e6db2b6ec72cd0414cc92395.png";